<mat-chip-set class="chip-grid">

    <div class="toggle-wrapper">
        @if(filterCount().count !== 0) {
        <mat-slide-toggle [checked]="filterIsActivated" mat-raised-button matTooltip="Filtrera"
            (change)="toggleAllChipsFilters($event)" class="toggle-slide" aria-label="Aktivera/Inaktivera"
            labelPosition="before">
        </mat-slide-toggle>
        }
    </div>

    @for (f of this.visibleChips() || []; track f.filter) {
    <mat-chip (removed)="removeFilter(f.filter, f.key)" (click)="toggleChipsFilter(f.filter)"
        [ngClass]="{ 'inactivate-filter' : !f.filter.activated }">
        @if(f.key === 'search') { <span>Sök: </span> }
        {{f.filter.value}}
        <button matChipRemove>
            <mat-icon>cancel</mat-icon>
        </button>
    </mat-chip>
    }

    @if(this.remainingCount() > 0) {
    <mat-chip> + {{ remainingCount() }} </mat-chip>
    }
    <div class="toggle-wrapper">
        @if(filterCount().count !== 0) {
        <div class="button-container">
            <button class="remove-button" mat-raised-button matTooltip="Rensa" (click)="removeAllFilters()">
                Rensa
            </button>
        </div>
        }
    </div>

</mat-chip-set>